import { jwtDecode } from 'jwt-decode';

interface UserObject {
  'custom:customer_id': string;
  sub: string;
  aud: string;
  event_id: string;
  token_use: string;
  auth_time: number;
  iss: string;
  'custom:user_id': string;
  'cognito:username': string;
  exp: number;
  iat: number;
}

export const identityIdFromToken = (idToken: string): string => {
  const decoded = jwtDecode(idToken);
  const userObject: UserObject = decoded as UserObject;
  const identityId = userObject['custom:user_id'];

  return identityId;
};
